const riot = require('riot');

riot.tag2('page-admin-distribution-rules-single', '<div class="f f s-full"> <div class="h100vh sticky t0" data-is="module-sidebar"></div> <div class="w-full f fclm bg-pale_gray"> <div class="flex-fixed" data-is="module-page-header" back="/admin/distribution-rules" title="{distributionRule.name}" breadcrumbs="{breadcrumbs}"></div> <div class="px40 py36 overflow-scroll"> <div class="f fclm section-padding bg-white rounded-8 elevation-default-low mb32"> <div class="text-gray_30 ts-hxs mb8">会社名</div> <div class="word-break-all text-navy ts-pm mb24">{distributionRule.company.name}</div> <div class="text-gray_30 ts-hxs mb8">プロジェクト名</div> <div class="word-break-all text-navy ts-pm mb24">{distributionRule.project.name}</div> <div class="text-gray_30 ts-hxs mb8">キャンペーン名</div> <div class="word-break-all text-navy ts-pm">{distributionRule.campaign.name}</div> </div> <div class="py32 bg-white rounded-8 elevation-default-low mb32"> <div class="px32"> <div class="mb36" data-is="module-section-header" title="配布設定"></div> <div class="text-gray_30 ts-hxs mb8">配布ルール名</div><a class="inline-block word-break-all text-blue_70 hover-trigger hover-text-blue_70 ts-pm mb24" href="{getLink()}" target="_blank">{distributionRule.name}</a> <div class="text-gray_30 ts-hxs mb8">ポイント配布方法</div> <div class="word-break-all text-navy ts-pm mb24">{getTargetLabel(distributionTargetStrategies[0].distribution_target_type)}</div> <div class="text-gray_30 ts-hxs mb8">ポイントサービス</div> <ul class="mb24"> <li class="word-break-all text-navy ts-pm list-position-inside mb8 mb0-last" each="{strategy in distributionPointStrategies}">{getPointLabel(strategy.point_provider)}</li> </ul> <div class="text-gray_30 ts-hxs mb8">ポイント付与回数の制限</div> <div class="word-break-all text-navy ts-pm mb24">{distributionRule.no_duplicate_account ? \'1アカウントあたり1回までに制限\' : \'制限しない\'}</div> <div class="text-gray_30 ts-hxs mb8">自動アーカイブ設定</div> <div class="word-break-all text-navy ts-pm">{distributionRule.archive_at ? dayjs(distributionRule.archive_at).format(\'YYYY-MM-DD\') : \'アーカイブ日を指定しない\'}</div> </div> </div> </div> </div> </div>', 'page-admin-distribution-rules-single,[data-is="page-admin-distribution-rules-single"]{display:block}', '', function(opts) {
    this.assets = [];
    this.files = [];
    this.selectOptions = [
      {id: 'draft', name: '否認'},
      {id: 'published', name: '承認'},
    ];
      this.buttons = [
      {
        type: 'submit',
        text: '保存',
        class: 'outline',
      },
    ];

    this.tableSchemas = [
      {
        id: 'file_name',
        component: 'image',
        label: 'ファイル名',
        class: 'w-full',
        getText: (v) => v.file_name,
        onclick: (v) => this.getFile(v),
      },
    ];

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      app.utils.auth.validateOperator();
      var companyId = req.params.company_id;
      var projectId = req.params.project_id;
      var campaignId = req.params.campaign_id;
      var distribution_rule_id = req.params.distribution_rule_id;
      var promises = [
        app.api.child(`companies/${companyId}/projects/${projectId}/distribution_rules/${distribution_rule_id}`).get(),
        app.api.child(`companies/${companyId}/projects/${projectId}/distribution_rule_assets`).get({ distribution_rule_id : distribution_rule_id }),
      ];
      var [{ distribution_rule }, { distribution_rule_assets }] = await Promise.all(promises);

      var isModifiable = (distribution_rule.status === "in_review" && !distribution_rule.archived_at);

      var breadcrumbs = [
        {
          link: '/admin/distribution-rules',
          label: "ダッシュボード",
        },
      ];

      return {
        companyId,
        projectId,
        campaignId,
        distributionRule: distribution_rule || '{}',
        distributionPointStrategies: distribution_rule.distribution_point_strategies || '{}',
        distributionTargetStrategies: distribution_rule.distribution_target_strategies || '{}',
        assets: distribution_rule_assets || '[]',
        isModifiable,
        breadcrumbs
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title('配布ルール', this),
      };
    };

    this.on('hide', () => {
      this.distributionRule = null;
      this.update();
    });

    this.hasImage = (content_type) => {
      return content_type.split('/')[0] === 'image';
    };

    this.onDownloadFile = async (asset) => {
      var url = asset.url;
      try {
        let res = await fetch(url);
        if (!res.ok) {
          console.error(res);
          spat.modal.alert('ダウンロードに失敗しました');
          return;
        }
        let blob = await res.blob();
        var url = URL.createObjectURL(blob, { type: asset.content_type });
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', asset.name);
        link.click();
        URL.revokeObjectURL(url);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert('ダウンロードに失敗しました');
      }
    };

    this.getTargetLabel = (target_type) => {
      return app.data.constants.distribution_target_types.find(t => t.id === target_type).name;
    };

    this.getPointLabel = (point_provider) => {
      return app.data.constants.point_providers.find(p => p.id === point_provider).name;
    };

    this.getFile = (asset) => {

      if (this.hasImage(asset.content_type)) {
        window.open(asset.url, '_blank');
      }

      else {
        this.onDownloadFile(asset);
      }
    };

    this.getLink = () => {
      return `/app/companies/${this.distributionRule.company.id}/projects/${this.distributionRule.campaign.project.id}/campaigns/${this.distributionRule.campaign.id}/distribution_rules/${this.distributionRule.id}`;
    };
});